import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { path } from 'ramda';
import { InfoCircleOutlined } from '@ant-design/icons';
import Button from '../../molecules/button';
import { useIntl } from 'common/config/i18n';

export type Props = {
  open: boolean;
  onClose: () => void;
  errorMessage?: string;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Text = styled.div`
  font-size: ${path(['theme', 'font', 'size', 'body'])};
  text-align: center;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
`;

const MessageModal: React.FC<Props> = ({ open, onClose, errorMessage }) => {
  const { t } = useIntl();

  return (
    <Modal footer={null} open={open} onCancel={onClose}>
      <Wrapper>
        <InfoCircleOutlined style={{ fontSize: 50, color: '#ff1A1A' }} />
        <Text>{errorMessage ? errorMessage : t('Modal', 'DELETE_MODAL', 'message')}</Text>
        <Button onClick={onClose} borderRadius="5px">
          {t('Modal', 'DELETE_MODAL', 'OK')}
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default MessageModal;
